import type {
  PublicGiftListItem,
  PublicSearchMetadata,
} from "./public-search-types";

export function mergePublicSearchPages(
  current: readonly PublicGiftListItem[],
  incoming: readonly PublicGiftListItem[],
): PublicGiftListItem[] {
  const merged: PublicGiftListItem[] = [];
  const seenIds = new Set<string>();

  for (const page of [current, incoming]) {
    for (const item of page) {
      if (seenIds.has(item.id)) continue;
      seenIds.add(item.id);
      merged.push(item);
    }
  }

  return merged;
}

export function getNextPage(metadata: PublicSearchMetadata): number | null {
  return metadata.hasNextPage ? metadata.page + 1 : null;
}

export interface LoadMoreFlightToken {
  readonly id: number;
  readonly page: number;
}

export class LoadMoreSingleFlight {
  private activeToken: LoadMoreFlightToken | null = null;
  private nextId = 1;

  get pendingPage(): number | null {
    return this.activeToken?.page ?? null;
  }

  tryStart(page: number): LoadMoreFlightToken | null {
    if (!Number.isInteger(page) || page < 1 || this.activeToken !== null) return null;

    const token = { id: this.nextId, page };
    this.nextId += 1;
    this.activeToken = token;
    return token;
  }

  finish(token: LoadMoreFlightToken): boolean {
    if (this.activeToken?.id !== token.id) return false;
    this.activeToken = null;
    return true;
  }

  reset(): void {
    this.activeToken = null;
  }
}
